import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";

export const useStaffMeta = () => {
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/staff/permissions").then((r) => setMeta(r.data)); }, []);
  return meta;
};

export const permLabel = (meta, key) => meta?.permissions.find((p) => p.key === key)?.label || key;

export const RoleBadge = ({ role }) => (
  <span className={`inline-flex px-2.5 py-0.5 rounded-full text-[11px] font-bold uppercase tracking-wide ${role === "amministratore" ? "bg-[#0F2942] text-white" : "bg-amber-100 text-amber-800"}`}
    data-testid="staff-role-badge">{role === "amministratore" ? "Amministratore" : "Dipendente"}</span>
);

export default function PermissionChecklist({ meta, value, onChange, disabled, lockedTo, testPrefix = "perm" }) {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {meta.permissions.map((p) => {
        const off = disabled || (lockedTo && !lockedTo.includes(p.key) && !value.includes(p.key));
        return (
          <label key={p.key} className={`flex items-center gap-3 p-3 rounded-lg border ${value.includes(p.key) ? "border-amber-300 bg-amber-50/60" : "border-slate-200"} ${off ? "opacity-60" : "cursor-pointer hover:bg-slate-50"}`}>
            <Checkbox checked={disabled || value.includes(p.key)} disabled={off} onCheckedChange={() => toggle(p.key)} data-testid={`${testPrefix}-${p.key}`} />
            <span className="text-sm font-medium">{p.label}</span>
          </label>
        );
      })}
    </div>
  );
}
